import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router';

export function useKeyboardShortcuts({ onNewLead, onPalette, onShortcuts, onToggleSidebar }) {
  const navigate = useNavigate();
  const pendingG = useRef(false);
  const gTimer = useRef(null);

  useEffect(() => {
    function isEditable(el) {
      if (!el) return false;
      const tag = el.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA') return true;
      if (el.isContentEditable) return true;
      return false;
    }

    function handler(e) {
      if (isEditable(document.activeElement)) return;

      const key = e.key;
      const meta = e.metaKey || e.ctrlKey;

      if (meta && key === 'k') {
        e.preventDefault();
        onPalette?.();
        return;
      }

      if (key === '?') {
        e.preventDefault();
        onShortcuts?.();
        return;
      }

      // ZYN-328: [ colapsa/expande a sidebar para modo reduzido (só ícones)
      if (key === '[') {
        e.preventDefault();
        onToggleSidebar?.();
        return;
      }

      if (key === 'g') {
        e.preventDefault();
        pendingG.current = true;
        clearTimeout(gTimer.current);
        gTimer.current = setTimeout(() => {
          pendingG.current = false;
        }, 300);
        return;
      }

      if (pendingG.current) {
        clearTimeout(gTimer.current);
        pendingG.current = false;

        if (key === 'd') { e.preventDefault(); navigate('/dashboard'); return; }
        if (key === 'p') { e.preventDefault(); navigate('/new-names'); return; }
        if (key === 'c') { e.preventDefault(); navigate('/contas'); return; }
      }
    }

    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('keydown', handler);
      clearTimeout(gTimer.current);
    };
  }, [navigate, onNewLead, onPalette, onShortcuts, onToggleSidebar]);
}
